import Swiper from 'swiper';
import { Scrollbar } from 'swiper/modules';
import initFollowCursor from './follow-cursor';

const initCarousels = (elements) => {
    elements.forEach((element) => {
        const sliderEl = element.querySelector('.swiper');
        const prevBtn = element.nextElementSibling.querySelector('.js-prev');
        const nextBtn = element.nextElementSibling.querySelector('.js-next');
        const mouseEl = element.querySelector('.js-follow-cursor');
        const scrollbarEl = element.nextElementSibling.querySelector('.swiper-scrollbar');

        const swiper = new Swiper(sliderEl, {
            modules: [Scrollbar],
            scrollbar: {
                el: scrollbarEl,
                draggable: false,
                dragSize: 'auto',
            },
            watchSlidesProgress: true,
            breakpoints: {
                0: {
                    slidesPerView: 1,
                },
                900: {
                    slidesPerView: 'auto',
                },
            },
        });

        const updateNavState = () => {
            const { progress } = swiper;

            if (progress <= 0.001) {
                prevBtn.classList.add('is-inactive');
            } else {
                prevBtn.classList.remove('is-inactive');
            }

            if (progress >= 0.999) {
                nextBtn.classList.add('is-inactive');
            } else {
                nextBtn.classList.remove('is-inactive');
            }
        };

        swiper.on('init', updateNavState);
        swiper.on('progress', updateNavState);
        swiper.on('slideChange', updateNavState);
        swiper.on('resize', updateNavState);

        updateNavState();

        prevBtn.addEventListener('click', () => {
            swiper.slidePrev();
            updateNavState();
        });

        nextBtn.addEventListener('click', () => {
            swiper.slideNext();
            updateNavState();
        });

        initFollowCursor(mouseEl, element);
    });
};

export { initCarousels as default };
